import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, IntlShape} from 'react-intl';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import DeleteButton from '../fw/DeleteButton.react';
import ScreenDisplayer, {ScreenDisplayerListener} from '../view/box-utils/ScreenDisplayer.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {invokeValidation} from '../channel-defs/ValidateDefinitionMutation.react';
import ValidationDefinitionResult from "../channel-defs/ValidationDefinitionResult.react";
import LoadingButton from '../fw/LoadingButton.react';
import FakePanel from '../scenarios/FakePanel.react';

import './EntityViewDef.scss';
import * as BrowserPermission from "../BrowserPermission";
import { User } from '../../common/types/types';

interface EntityViewDefViewProps {
    relay: object;
    user: User;
}

export class EntityViewDefView extends React.Component<EntityViewDefViewProps> {

    typeName = 'entityViewDefs';

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.state = {
            validationResult: null
        };
    }

	static constructViewWithData(entityViewDef, entityDef) {
		return {
			view: {
				id: entityViewDef ? entityViewDef['realId'] : null,
				realId: entityViewDef ? entityViewDef['realId'] : null,
				entityViewDef: entityViewDef || {},
			},
			data: '[]',
			entityDef:  entityDef,
			addon: '{}',
		};
	}

    onClickValidate = () => {
        return invokeValidation(this.props.relay, (validationResult) => {
            this.setState({
                'validationResult': validationResult
            });
        }, {
            entityViewDef: this.props.user.entityDef.entityViewDef
        });
    };

    render() {
        const data = this.props.user.entityDef.entityViewDef;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['entityDefs'], data: this.props.user.entityDef},
            ]} title={data.name}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={data} metadata={type} urlMapping={urlMapping}>
                        <DeleteButton
                            data={data}
                            deleteFatQuery={Relay.QL `fragment on DeleteEntityViewDefPayload {
                                                        updatedNode {
                                                            id
                                                        },
                                                        entityDef {
                                                            entityViewDefs(first: 2000) {
                                                                edges {
                                                                    node {
                                                                        id
                                                                    }
                                                                }
                                                            }
                                                        }

                                                    }`}
                            deleteMutation={Relay.QL `mutation { deleteEntityViewDef }`}
                            metadata={type}
                            parent={this.props.user.entityDef}
                            types={types}
                            urlMapping={urlMapping}
                        />
                        {type.canUpdate(BrowserPermission.getPermissionObject(), data) ? <LoadingButton className="btn btn-default" onClick={this.onClickValidate}><span className="fa fa-check"/> <FormattedMessage defaultMessage="Validate" id="channelDef.validate" /></LoadingButton> : null}
                    </DetailToolBar>

                    <ValidationDefinitionResult validationResult={this.state.validationResult}/>

                    <h2>{data.name}</h2>
                    <TableDetail columns={{'name':{}, 'description':{}, 'title':{}, 'handler':{}, 'forList': {}, 'hideInDefaultQuery': {}, 'defaultUsage': {}, 'dependsOnChannelDef.name': {}, 'dependentChannelRequirement': {}, 'backendHandlers': {}, 'state': {}, 'visibility': {}}} data={data} metadata={type} />
                </DetailBox>

				<div className="entityDefViewPanelPreview">
					<h3><FormattedMessage defaultMessage="Preview" id="entityViewDefView.preview" /></h3>
					<FakePanel>
						<ScreenDisplayer
							content={{
								"views": [
									data['realId']
								],
								"layout": "list"
							}}
							isPreview
							listener={new ScreenDisplayerListener()}
							relay={this.props.relay}
							viewsWithData={[EntityViewDefView.constructViewWithData(data, this.props.user.entityDef)]}
						/>
					</FakePanel>
				</div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(EntityViewDefView, (props) => {
    return props.user.entityDef && props.user.entityDef.entityViewDef;
}), {
    initialVariables: {
        entityDefId: '',
        entityViewDefId: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                entityDef(id: $entityDefId) {
                    id,
                    key,
                    name,
                    icon,
                    inheritedIcon,
                    groupDef_id,
                    allFieldDefs(first: 20000) {
                        edges {
                            node {
                                id,
                                realId,
                                name,
                                shortName,
                                exampleData,
                                key,
                                type
                            }
                        }
                    },
                    entityViewDef(id: $entityViewDefId) {
                        id,
                        realId,
                        name,
                        hideInDefaultQuery,
                        forList,
                        description,
                        entityDef_id,
                        entityDef {
                            id,
                            icon,
                        },
                        dependentChannelRequirement,
                        dependsOnChannelDef {
                            id,
                            name,
                            icon,
                        },
                        title,
                        defaultUsage,
                        backendHandlers,
                        template,
						filter,
						order,
                        handler,
                        state,
                        visibility
                    }
                }
            }
        `,
    },
});
